module.exports = __webpack_public_path__ + "media/images/img_about_02-d153fe19349e03906a53681b13ca1bd3.png";